/**
 * vuex getters
 */
export default {
  test(state) {
    return state.test
  },
}
